import { render, staticRenderFns } from "./DrawableInfo.vue?vue&type=template&id=334c871a&scoped=true"
import script from "./DrawableInfo.vue?vue&type=script&lang=js"
export * from "./DrawableInfo.vue?vue&type=script&lang=js"
import style0 from "./DrawableInfo.vue?vue&type=style&index=0&id=334c871a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "334c871a",
  null
  
)

export default component.exports